import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

/**
 * Custom hook for handling StudentDashboard authentication and authorization
 * @param {boolean} isAdminOverride - Whether this is an admin viewing student data
 * @returns {Object} Authentication state and user info
 */
export const useStudentDashboardAuth = (isAdminOverride = false) => {
  const {
    isLoggedIn,
    user,
    roles,
    isLoading: authLoading
  } = useRoleAuthentication({
    redirectOnUnauthorized: false
  });

  // Skip authentication checks if in admin mode
  const shouldSkipAuth = isAdminOverride;
  const isAuthenticated = shouldSkipAuth || isLoggedIn;

  return {
    isLoggedIn,
    user,
    roles,
    authLoading,
    isAuthenticated,
    shouldSkipAuth
  };
};

export default useStudentDashboardAuth;